import store from "@/store";
import UNCoopModule from "./store";

export default [
  {
    path: "/un-coop",
    redirect: "/un-coop/projects",
    component: () => import("./moduleLayout.vue"),
    beforeEnter(to, _, next) {
      if (!store.hasModule("UNCoop"))
        store.registerModule("UNCoop", UNCoopModule);
      next();
    },
    children: [
      {
        path: "projects",
        name: "un-coop-projects",
        component: () => import("./pages/projects-view/index.vue"),
        meta: {
          pageTitle: "مشاريع التعاون مع  منظمات الأمم المتحدة",
          slug: "ngo_un_coop",
          breadcrumb: [
            {
              text: "مشاريع التعاون مع  منظمات الأمم المتحدة",
              active: true,
            },
          ],
        },
      },
      {
        path: "projects/:id",
        props: true,
        name: "un-coop-project",
        component: () => import("./pages/project-details/index.vue"),
        meta: {
          pageTitle: "معلومات المشروع",
          slug: "ngo_un_coop",
          breadcrumb: [
            {
              text: "مشاريع التعاون مع  منظمات الأمم المتحدة",
              to: "/un-coop/projects",
            },
            {
              text: "معلومات المشروع",
              active: true,
            },
          ],
        },
      },
      {
        path: "international_events_subscriptions",
        name: "un-coop-international-events-subscriptions",
        component: () => import("./pages/international-events-subscriptions/index.vue"),
        meta: {
          pageTitle: "الغعاليات المُشارك بها خارج القطر",
          slug: "ngo_international_events_subscriptions",
          breadcrumb: [
            {
              text: "الغعاليات المُشارك بها خارج القطر",
              active: true,
            },
          ],
        },
      },
      {
        path: "I-organisations-memberships",
        name: "un-coop-I-organisations-memberships",
        component: () => import("./pages/I-organisations-memberships/index.vue"),
        meta: {
          pageTitle: "طلبات الإنتساب لمنظمة دولية",
          slug: "ngo_international_organisations_memberships",
          breadcrumb: [
            {
              text: "طلبات الإنتساب لمنظمة دولية",
              active: true,
            },
          ],
        },
      },
      {
        path: "collaboration-two-local-partners",
        name: "collaboration-two-local-partners",
        component: () => import("./pages/collaboration-two-local-partners/index.vue"),
        meta: {
          pageTitle: "التعاون بين شريكين محليين",
          slug: "ngo_collaboration_two_local_partners",
          breadcrumb: [
            {
              text: "التعاون بين شريكين محليين",
              active: true,
            },
          ],
        },
      },
    ],
  },
];
